<template>
    <div>
        <v-toolbar dense elevation="0">
            <v-toolbar-title class="text-h5"></v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn @click="openEditModal(note.id)" :id="'edit' + note.id" color="dark-grey" class="mt-1" icon right>
                <v-icon center>mdi-pencil</v-icon>
                        <v-tooltip :activator="'#edit'+ note.id" bottom open-delay="500">
                            <span>{{$page.props.lang.editNote || "Edit note"}}</span>
                        </v-tooltip>    
            </v-btn>
             <v-btn @click="deleteNote(note.id, true)" :id="'delete' + note.id" class="delete-icon mt-1" icon right>
                        <v-icon center>mdi-trash-can-outline</v-icon>
                        <v-tooltip :activator="'#delete'+ note.id" bottom open-delay="500">
                            <span>{{$page.props.lang.deleteNote || "Delete note"}}</span>
                        </v-tooltip>
                    </v-btn>
        </v-toolbar>
        <div v-html="note.description">
        </div>
       
         
            <v-list-item>
                <v-list-item-avatar size="30px">
                    <!-- <img :src="note.created_by.profile_photo_url+'?w=30'"> -->
                </v-list-item-avatar>
                <v-list-item-content>
                    <!-- <p class="pt-9" style="font-size: 15px"> {{ note.created_by.first_name + ' ' + note.created_by.last_name }} </p> -->
                    <p style="text-align:right; font-size: 15px"> {{ note.created_at | fullDate }} </p>
                </v-list-item-content>
            </v-list-item>
       
        <v-divider></v-divider>
    </div>
</template>

<script>
import EventBus from '@/js/eventbus'
export default{
    props: {
        note: {
            type: Object,
            required: true
        }
    },
    methods: {
        openEditModal() {
            
            axios.get('/backoffice/members/getNote/'+ note.id)
                .then(response => {
                    if(response.data.status === "OK"){
                        this.editModal = true
                        this.currentNote = response.data.note
                    }else{
                        alert("Server error.")
                    }
                })
        },
         deleteNote(id, showConfirmation) {
            if(showConfirmation){
                this.deleteNotesModal = true;
                this.cNoteId = id;
                return;
            }
            axios.post('/backoffice/members/deleteNote', {id: id})
                .then(response => {
                     this.deleteNotesModal = false;
                    if(response.data.status==="OK") {
                        this.$inertia.reload({only:['member']})
                        EventBus.$emit('SHOW_NOTIFICATION',{
                                message: response.data.message,
                                color: 'success',
                                timeout: 5000
                            })
                    }
                })
                .catch(function (error) {
                     this.deleteNotesModal = false;
                     EventBus.$emit('SHOW_NOTIFICATION',{
                            message: error.response.data.message,
                            color: 'error',
                            timeout: 10000
                        })
                })
        }
    }
}
</script>